// Must stay the first imports: they take the Poseidon session token off an /internal/open URL
// and the email-action request off an /auth/action URL before the Firebase client (whose
// analytics page view carries the full URL) or the router load.
import "./internalOpenToken";
import "./authAction";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import Gleap from "gleap";
import "./index.css";

// Gleap.initialize(process.env.REACT_APP_GLEAP_KEY);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
